module.exports = __webpack_public_path__ + "img/bullhorn.f8c0e84b.svg";